export default {"src":"/_next/static/media/cryo.1d9e938e.svg","height":74,"width":108};